// Persisted time-machine step status is only ever 'success' or 'error' (the recorder's normalizeStepStatus collapses
// everything to those two before upload). Maps a raw step status to its display label and badge variant.
const getWorkflowRunStepStatusPresentation = (status) => {
  const normalized = String(status || '')
    .trim()
    .toLowerCase();

  if (normalized === 'success') {
    return { label: 'Succeeded', variant: 'success' };
  }

  if (normalized === 'error') {
    return { label: 'Failed', variant: 'failure' };
  }

  return { label: 'Unknown', variant: 'neutral' };
};

export default getWorkflowRunStepStatusPresentation;
